import React from 'react';
import Equipe from '../Equipe';

function EquipePage() {
    return (
        <>
            <Equipe />
        </>
    )
}

export default EquipePage;